import { render, staticRenderFns } from "./SelectNative.vue?vue&type=template&id=b0bc39d4&"
import script from "./SelectNative.vue?vue&type=script&lang=js&"
export * from "./SelectNative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports